export class MovimientoTraspasoCreateDto {
    constructor() {
        this.idPacienteOrigen = null;
        this.idPacienteDestino = null;
        this.idAreaSolicitud = null;
        this.idClinica = null;
        this.idEmpleadoSolicito = null;
        this.monto = null;
        this.archivos = [];
    }
}